import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Col,
  Label,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import ToastDialog from "components/Common/ToastDialog";
import { callLogoutUser } from "http/auth/login";
import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";

// users
import user4 from "../../../assets/images/users/avatar-9.jpeg";

import { decryptedValue, getRoleName } from "../../../common/utility";

import { editUserConsent } from "../../../http/fundLync/user.helper";

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const [readMore, setReadMore] = useState(false);
  let user = decryptedValue(localStorage.getItem("user"));
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const navigate = useNavigate();

  const { data } = useSelector(state => ({
    data: state.Login.data,
  }));
  let roleName = 'admin';
  if (data) {
    roleName = getRoleName(data.roleId);
  }
  const [username, setusername] = useState(user.firstName);

  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isUserConsent, setIsUserConsent] = useState(false);
  const [isAgree, setIsAgree] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);


  const toggleProfile = () => {
    setIsProfileOpen(!isProfileOpen);
  };

  useEffect(() => {
    const user = decryptedValue(localStorage.getItem("user"));
    let flag = (user.firstLogin && !user.userConsent && user.entityType == 'Customer')
    setIsUserConsent(flag)
  }, []);


  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.email);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.username);
      }
    }
  }, [props.success]);

  const logout = async () => {
    let tokenBody = JSON.parse(localStorage.getItem('tokens'))
    let payLoad = {
      refresh_token: tokenBody?.refresh?.token,
      access_token: tokenBody?.access?.token,
    }
    await callLogoutUser(payLoad)
    localStorage.clear();
  }

  const getUserImageSource = () => {
    return user4;
  };

  const userImageSource = getUserImageSource();

  const changeUserConsent = (id) => {
    if (!isAgree) {
      setErrorMessage('Please accept the consent')
    } else {
      setErrorMessage(false)
      editUserConsent({ id })
        .then((response) => {
          if (response.status) {
            setToastInfo({
              message: response.message,
              showToast: true,
              role: "success",
            });
            user.firstLogin = false
            
            const passphrase = process.env.REACT_APP_KEY;
            const encryptedUser = CryptoJS.AES.encrypt(
              JSON.stringify(user),
              passphrase
            ).toString();

            localStorage.setItem("user", encryptedUser)
            user = decryptedValue(localStorage.getItem("user"));
            setIsUserConsent(false)
          } else {
            setToastInfo({
              message: response.message,
              showToast: true,
              role: "error",
            });
          }
        })
    }
  }

  const handleLogout = () => {
    logout();
    const currentUrl = window.location.href;
    if (currentUrl.includes("fundlync") || currentUrl.includes("fundlyncuat") || currentUrl.includes("localhost")) {
      navigate("/login");
    } else {
      navigate('/internal-login');
    }
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img className="rounded-circle header-profile-user" src={userImageSource} />
          <span className="d-none d-xl-inline-block ms-2 me-1">Hello {username}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">

          <DropdownItem onClick={toggleProfile}>

            <Modal isOpen={isProfileOpen} toggle={toggleProfile} className="pop">

              <ModalHeader toggle={toggleProfile} className="border-bottom-0"></ModalHeader>

              <ModalBody className="top">
                <p className="d-flex"><b>Name : </b> {user.firstName} {user.lastName} </p>
                <p className="d-flex"><b>Email : </b> {user.email}  </p>
                <p className="d-flex"><b>Role : </b> {user.roleName}   </p>
                <p className="d-flex"> <b> Entity Name : </b>{user.entityName} </p>
              </ModalBody>

            </Modal>

            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}{" "}
          </DropdownItem>
          <div className="dropdown-divider" />
          <div onClick={handleLogout} className="dropdown-item" style={{ cursor: 'pointer' }}>
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </div>
        </DropdownMenu>
      </Dropdown>

      <Modal isOpen={isUserConsent}
        role="<dialog>"
        autoFocus={true}
        centered
        data-toggle="modal"
      >
        <ModalHeader className="border-bottom-0"></ModalHeader>
        <ModalBody className="top">
          <div className="modal-body vertical-scroll" style={{ height: "500px" }}>
            <h2 className="text-center" style={{ color: '#2f94c8' }}>Consumer Consent Form</h2>
            <p style={{ textAlign: 'justify', fontWeight: '600' }} className="font-size-14">
              Consumer Consent for accessing Consumer Credit Information Report (CIR)
            </p>

            <p style={{ textAlign: 'justify' }} className="font-size-14">
              I hereby appoint Indinvoice Tech Solutions Private Limited (hereinafter referred as
              "Company"), having its registered office at A/2003 Stellar, Amforge Compound, LBS Marg,
              Bhandup-West, Mumbai - 400078, as my lawful agent to receive my credit report/credit history ("Credit Information") from Credit Information Companies ("CICS").
            </p>

            <p style={{ textAlign: 'justify' }} className="font-size-14">
              I further authorize the Company to share with CICS, my personal information/details toprocure my Credit Information on a monthly frequency and use the same to provide me with credit assessment and availing loan service ("Purpose").
            </p>

            <p style={{ textAlign: 'justify' }} className="font-size-14">
              I understand and acknowledge that the CIC shall not be liable under law or equity, in any
              manner whatsoever, for providing my Credit Information to the Company and I will not raise any claim or objections against the CIC.
            </p>

            <p style={{ textAlign: 'justify' }} className="font-size-14">
              1 confirm that this consent is given by my free will and not due to any solicitation by any
              person/entity.
            </p>

            <p style={{ textAlign: 'justify' }} className="font-size-14">
              This consent/authorization shall be valid for (i) a maximum period of 06 (six) months, from the date of giving the same, (ii) satisfying the Purpose or (iii) until I withdraw my consent at any time, by informing the same to the Company, at their registered office address, website,
              assigned email id or mobile application, whichever is earlier.
            </p>

            <p style={{ textAlign: 'justify', fontWeight: '450' }} className="font-size-14">
              I also consent to the CRIF High Mark Credit Score Terms of Use
            </p>

            {!readMore && (
              <p
              >
                CRIF High Mark <span style={{
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  color: 'blue',
                }}
                  className="font-size-14"
                  onClick={() => {
                    setReadMore(true);
                  }}>Credit Score Terms of Use</span>
              </p>
            )}
            {readMore && (<div>
              <p style={{ textAlign: 'justify', fontWeight: '600' }} className="font-size-14">
                CRIF High Mark -Credit Score Terms of Use
              </p>

              <p style={{ textAlign: 'justify' }} className="font-size-14">
                In connection with submission of the application for my credit information ("Consumer Credit
                Information") offered by CRIF High Mark Credit Information Services Pvt. Ltd. ("CIC") through Indinvoice Tech Solutions Private Limited (referred to as the "Company") and delivery of the Consumer Credit Information to the Company, I hereby acknowledge and agree to the following:
              </p>

              <ol type="A">
                <li style={{ textAlign: 'justify' }} className="font-size-14">The Company is my lawfully appointed agent and he / it has agreed to be my agentobtainmy Credit Information Report and Credit Score from CRIF High Mark Credit InformationServices Pvt. Ltd (CRIF High Mark) for the purpose of credit assessment and availingloan and not for any other purposes. This consent shall be valid for a maximum period of 6months or till such time the credit information is required to be retained to satisfy thepurpose for which it was intended, or I withdraw my consent to store such creditinformation, whichever is earlier.</li>
                <li style={{ textAlign: 'justify' }} className="font-size-14 mt-2"> I hereby expressly grant unconditional consent to, and direct, CIC to deliver and / ortransfer my Consumer Credit Information to the Company on my behalf.</li>
                <li style={{ textAlign: 'justify' }} className="font-size-14 mt-2">I shall not hold CIC responsible or liable for any loss, claim, liability, or damage ofany kindresulting from, arising out of, or in any way related to: (a) delivery of my Consumer CreditInformation to the Company: (b) any use, modification or disclosure by the Company ofthe contents, in whole or in part, of my Consumer Credit Information, wherever authorizedby me; (c) any breach of confidentiality or privacy in relation to delivery of my ConsumerCredit Information to the Company</li>
                <li style={{ textAlign: 'justify' }} className="font-size-14 mt-2">I acknowledge and accept that: (a) CIC has not made any promises or representations tome in order to induce me to provide my Consumer Credit Information or seek any consentor authorization in this regard; and (b) the implementation of the Agreement between CICand the Company is solely the responsibility of the Company.</li>
                <li style={{ textAlign: 'justify' }} className="font-size-14 mt-2"> I agree that I may be required to record my consent / provide instructions electronically orphysically as the case may be, and in all such cases I understand that by clicking on the "IAccept" button below or signing this Consent physically. I am providing "writteninstructions to the Company authorizing Company to obtain my Consumer CreditInformation from my personal credit profile from CRIF High Mark. I further authorizeCompany to obtain such information solely to confirm my identity and display myConsumer Credit Information to me. Further in all such cases by checking this box andclicking on the Authorize button or signing this Consent physically. I agree to the termsand conditions, acknowledge receipt of CIC privacy policy and agree to its terms, andconfirm my authorization for Company to obtain my Consumer Credit Information.</li>
                <li style={{ textAlign: 'justify' }} className="font-size-14 mt-2"> I understand that in order to deliver the product to me, I hereby authorize Company to obtain my Consumer Credit Information from CIC.</li>
                <li style={{ textAlign: 'justify' }} className="font-size-14 mt-2">By submitting this registration form, I understand that I am providing express writteninstructions for Company to request and receive a copy of my consumer credit report andscore from CIC.</li>
                <li style={{ textAlign: 'justify' }} className="font-size-14 mt-2"> I understand that the product is provided on an "as-is", "as available" basis and CICexpressly disclaims all warranties, including the warranties of merchantability, fitness for aparticular purpose, and non-infringement.</li>
                <li style={{ textAlign: 'justify' }} className="font-size-14 mt-2">I shall not sue or otherwise make or present any demand or claim, and I irrevocably.unconditionally and entirely release, waive and forever discharge CIC, its officers,directors, employees, agents, licensees, affiliates, successors and assigns, jointly andindividually (hereinafter "Releasee"), from any and all manner of liabilities, claims,demands, losses, claims, suits, costs and expenses (including court costsand reasonableattorney fees) ("Losses"), whatsoever, in law or equity, whether known or unknown,which I ever had, now have, or in the future may have against the Releasee with respectto the submission of my Consumer Credit Information and / or my decision to provide CICwith the authority to deliver my Consumer Credit Information to the Company. I agree todefend, indemnify, and hold harmless the Releasee from and against any and all lossesresulting from claims made against CIC by third parties arising from and in connectionwith this letter.</li>
                <li style={{ textAlign: 'justify' }} className="font-size-14 mt-2"> I agree that the terms of this confirmation letter shall be governed by the laws of India andshall be subject to the exclusive jurisdiction of the courts located in Mumbai in regard toany dispute arising hereof.</li>


              </ol>
            </div>)}

            {readMore && (<Col lg="12">
              <div className="form-check">
                <Input
                  type="checkbox"
                  className="form-check-input"
                  id="invalidCheck"
                  value={isAgree}
                  onChange={() => {
                    setIsAgree(!isAgree)
                    if (!isAgree) {
                      setErrorMessage(false)
                    }
                  }}
                  style={{ borderColor: "#ced4da" }}
                />
                <Label
                  className="form-check-label"
                  htmlFor="invalidCheck"
                >
                  {" "}
                  I Agree{" "}
                </Label>
              </div>
              {errorMessage && (
                <span
                  style={{
                    color: "rgb(245,116,116)",
                    fontSize: "11px",
                  }}
                >
                  {errorMessage}
                </span>
              )}
            </Col>)}
            {readMore && (<Col className="mt-2 d-flex justify-content-center">
              <button className="btn btn-outline-success" onClick={() => { changeUserConsent(user.id) }}>Submit</button>
            </Col>)}
          </div>
        </ModalBody>

      </Modal>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
